import { useEffect, useRef, RefObject } from 'react';
import { AdUnitRef } from './AdUnit';

export function useAdRefresh(adRef: RefObject<AdUnitRef | null>, trigger: unknown): void {
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the initial render — only refresh on subsequent trigger changes
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    adRef.current?.requestRefresh();
  }, [trigger, adRef]);
}
